import { useState } from "react";
import { X } from "lucide-react";
import { Pic } from "../Pic";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

export const PhotoMarquee = ({ items, testId = "photo-marquee" }) => {
  const [open, setOpen] = useState(null);
  return (
    <>
      <div data-testid={testId} className="filmstrip relative -mx-5 overflow-hidden sm:-mx-8">
        <div className="filmstrip-track marquee-slow flex w-max gap-4 px-5 sm:px-8">
          {[...items, ...items].map((img, i) => (
            <button key={i} type="button" onClick={() => setOpen(img)} aria-hidden={i >= items.length} tabIndex={i >= items.length ? -1 : 0} data-testid={i < items.length ? `marquee-photo-${i}` : undefined}
              className="group w-[200px] shrink-0 overflow-hidden rounded-2xl ring-1 ring-black/10 shadow-[0_20px_40px_-24px_rgba(0,0,0,0.5)] transition-transform duration-300 hover:-translate-y-1 sm:w-[260px]" aria-label={i < items.length ? `Open photo: ${img.alt}` : undefined}>
              <Pic src={img.src} alt={i < items.length ? img.alt : ""} sizes="260px" className="aspect-[4/3] h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </button>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent data-testid="photo-lightbox" className="max-w-4xl overflow-hidden rounded-2xl border-0 !bg-black p-0 text-white">
          {open && (
            <figure>
              <DialogTitle className="sr-only">{open.alt}</DialogTitle>
              <img src={open.src} alt={open.alt} width={open.w} height={open.h} className="max-h-[80vh] w-full object-contain" />
              <figcaption className="px-5 py-3 text-sm text-white/80">{open.alt}</figcaption>
            </figure>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
